import { Component, OnInit, ViewChild, Output, EventEmitter, HostListener, ElementRef, Input } from '@angular/core';
import { CompanyFormComponent } from '../../company-form/company-form.component';
import { PlanMainService } from '../../plan/service/plan-main.service';

@Component({
  selector: 'app-business-manage-dialog',
  templateUrl: './business-manage-dialog.component.html',
  styleUrls: ['./business-manage-dialog.component.css']
})
export class BusinessManageDialogComponent implements OnInit {
  public isChkMenuEnabledtoShow = [];
  public isMenuAutho;
  public menuAuthoMap: Map<string, number> = new Map();
  listbtn: string = "";
  @ViewChild("form") companyform: CompanyFormComponent;
  @Output('close') close: any = new EventEmitter<any>();
  @Output('clickoutside') clickoutside: any = new EventEmitter<any>();
  constructor(private element: ElementRef, private planmainService: PlanMainService) { }

  @HostListener('document:click', ['$event'])
  handleClick(event: Event) {
    let target = (<HTMLInputElement>event.target);
    if (!this.element.nativeElement.contains(event.target) && target.parentElement.className.indexOf('submenu') == -1) {
      this.clickoutside.emit();
    }
  }
  ngOnInit() {

    this.planmainService.menuAutho.subscribe((res: any) => {
      if (res) {
        this.menuAuthoMap = <Map<string, number>>Object.values(res)
          .reduce(
            (acc: Map<string, number>, value: { menuId: string, enabled: number }) =>
             acc.set(value.menuId, value.enabled), new Map()
          );
      }
    });

  }

  ToggleSubMenu(key: string) {
    if (this.listbtn == key) {
      this.listbtn = '';
    } else {
      this.listbtn = key;
    }
  }

  IsShow(key: string) {
    return this.listbtn == key;
  }

  Submit(value: string) {
    this.companyform.setFromAndSubmit(value);
  }

  onClose() {
    this.close.emit();
  }

  checkMenuAutho(menuName: string): boolean {
    if (this.menuAuthoMap.has(menuName)) {
      return this.menuAuthoMap.get(menuName) === 1;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/business-manage/business-manage-dialog/business-manage-dialog.component.ts